import { cn } from "../../../helpers";
import { Card } from "../Card/Card";
import styles from "./EmptyListState.module.scss";

interface ListStateProps {
    /** Class for adding more styling to wrapper card */
    cardClass?: string;
    /** Class for styling state component inner container */
    wrapperClass?: string;
    /** Text to display useful information about the current state */
    stateHelperText?: string;
    /** Empty state message */
    emptyMessage?: string;
}

export default function EmptyListState({
    stateHelperText,
    wrapperClass,
    emptyMessage,
    cardClass,
}: ListStateProps) {
    return (
        <Card classNames={cardClass}>
            <div className={cn(styles.wrapper, wrapperClass)}>
                <p className={styles.emptyMessage}>{emptyMessage}</p>
                <p className={styles.helperText}>{stateHelperText}</p>
            </div>
        </Card>
    );
}
